/** @flow */
import styled from "styled-components";

const StyledDropdown = styled.div`
  position: relative;
`;

export default StyledDropdown;
